export default __webpack_public_path__ + "static/media/chat_join_friend.59ec46f1.mp3";